
import React, { useEffect, useState } from 'react';
import "./Advance.css";
import CodeMirror from '@uiw/react-codemirror';
import 'codemirror/keymap/sublime';
import 'codemirror/theme/monokai.css';
import { listEduvanceAITools, getEduvanceAiUsers, listEduvanceAiUsers } from '../../graphql/queries';
import { createEduvanceAITool, createEduvanceAiUsers, updateEduvanceAITool, deleteEduvanceAITool } from '../../graphql/mutations';
import { API, Storage } from 'aws-amplify';

import { Auth } from 'aws-amplify';

import Grid from '@material-ui/core/Grid';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";
import { Code } from '@material-ui/icons';
import { useParams } from "react-router-dom";

import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import Modal from '@material-ui/core/Modal';

import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        position: 'absolute',
        // width: '60vw',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

Storage.configure({
    customPrefix: {
        public: 'projects/',
        protected: 'myProtectedPrefix/',
        private: 'myPrivatePrefix/'
    },
    // ...
});


const Advance = (props) => {
    const classes = useStyles();
    let { uname, pname } = useParams();

    const code = '#write your code below \n\n\n\n\n\n\n\n\n\n\n';
    const [codetemp, setCodetemp] = useState(code);
    const [runButtonStatus, setRunButtonStatus] = useState(false);

    const [responseJson, setResponseJson] = useState('');
    const [mappingjson, setMappingJson] = useState({
        "inputs": "",
        "outputs": "",
        "algorithm": "",
        "testsize": "",
        "epochs": ""
    });

    const [outputData, setOutputData] = useState("");
    const [errorData, setErrorDate] = useState("");
    const [exitCode, setExitCode] = useState("");

    const [modelSaved, setModelSaved] = useState(false);
    const [couponModalOpen, setCouponModalOpen] = useState(false);

    const [isPremium, setIsPremium] = useState(false);

    var oldDate, newDate;


    function getConfigDate(url, wch) {
        try {
            var req = new XMLHttpRequest();
            req.open("GET", url, false);
            req.setRequestHeader('Cache-Control', 'no-cache');
            req.send(null);
            if (req.status == 200) {
                return new Date(req.getResponseHeader(wch));
            }
            else return false;
        } catch (er) {
            return er.message;
        }
    }

    const handlecouponModalOpen = () => {
        setCouponModalOpen(true);
    };

    const handleCouponModalClose = () => {
        setCouponModalOpen(false);
    };
    const handleModelSavedClose = () => {
        setModelSaved(false);
    }

    const verifyCoupon = () => {
        var couponid = document.getElementById("couponid").value;
        var username = localStorage.getItem("CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser");
        var userdata = localStorage.getItem(`CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`);
        var jsondata = JSON.parse(userdata);
        var data = `${username}//${ jsondata["UserAttributes"][jsondata["UserAttributes"].length - 2]["Value"]}`;
        var xhr = new XMLHttpRequest();
        xhr.addEventListener("readystatechange", function () {
            if (this.readyState === 4) {
                // console.log(this.responseText);
                if (this.responseText === "Coupon successfully redeemed") {
                    alert("coupon successfully redeemed");
                    window.location.reload();
                }
                else
                    alert(this.responseText);
            }
        });
        xhr.open("POST", `https://s2v68e8y9a.execute-api.ap-south-1.amazonaws.com/dev/coupon?coupon=${couponid}&type=redeem`);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        xhr.send(data);
    }

    async function signOut() {
        try {
            await Auth.signOut({ global: true });
            window.location.reload();
        } catch (error) {
            // console.log('error signing out: ', error);
        }
    }

    const handleRun = () => {

        // setActiveStep((prevActiveStep) => 0);
        // setProgressBar(false);
        // setModalOpen(true);
        setRunButtonStatus(true);
        // document.getElementById("runButton").setAttribute("disabled", "true");
        setResponseJson('');
        setOutputData("Generating output please wait....");
        setErrorDate("");
        setExitCode("");
        // setModelSaved(false);

        // console.log(data);
        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        // setNextButtonDisabled(false);
        // setProgressBar(false);
        oldDate = getConfigDate(`https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${localStorage.getItem('CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser')}/config.json`, 'Last-Modified');
        trainModel();
    }

    async function deleteJson() {
        await Storage.remove(`${localStorage.getItem('CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser')}/advance.json`);
    }

    const getConfigJson = () => {
        fetch(`https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${localStorage.getItem('CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser')}/advance.json`)
            .then(response => response.json())
            .then(json => {
                setResponseJson(json); console.log("here is output " + decodeURIComponent(json['data']) + " error " + json['error'] + " and exit code " + json['exitcode']);
                setOutputData(decodeURIComponent(json['data']));
                setErrorDate(decodeURIComponent(json['error']));
                setExitCode(decodeURIComponent(json['exitcode']));
                setRunButtonStatus(false);
                // document.getElementById("runButton").removeAttribute("disabled");
            });
    }

    const trainModel = () => {
        deleteJson();
        var mapping = {};

        mapping["username"] = localStorage.getItem('CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser');
        mapping['algorithm'] = "ADVANCE";
        mapping['code'] = encodeURIComponent(codetemp);
        if (localStorage.getItem("validity") == "free") {
            mapping['validity'] = "free";
        }
        else {
            mapping['validity'] = "premium";
        }
        setMappingJson(mapping);
        console.log("here is mapping" + mapping);
        // var data = JSON.stringify({"username":"swapbawa","datafile":"https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/swapbawa/iris.csv","algorithm":"RFC","testsize":0.2,"inputs":["Petal_width","Petal_length"],"outputs":["Flower"],"value":[[5.1,3.5]]});
        var data = JSON.stringify(mapping);
        var xhr = new XMLHttpRequest();

        xhr.addEventListener("readystatechange", function () {
            if (this.readyState === 4) {
                console.log(this.responseText);
                var valjson = {};
                try {
                    valjson = JSON.parse(this.response);
                    console.log("val json" + valjson['body']);
                    if (valjson["body"] == '"Daily limit reached!"') {
                        alert("Daily limit reached!");
                    }
                    else {

                        try {
                            // console.log(tempjson2['accuracy']);
                            var timerfun = setInterval(() => {
                                newDate = getConfigDate(`https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${localStorage.getItem('CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser')}/advance.json`, 'Last-Modified');
                                console.log("here is old date " + oldDate + " and here is new date " + newDate);
                                if (newDate > oldDate) {
                                    getConfigJson();
                                    clearInterval(timerfun);

                                }
                            }, 5000);
                        }
                        catch (e) {
                            console.log(e);

                        }
                    }
                }
                catch {
                    console.log("Error");
                }


            }
        });

        xhr.open("POST", "https://s2v68e8y9a.execute-api.ap-south-1.amazonaws.com/dev/train");
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.send(data);
    }

    async function saveModel() {

        if (document.getElementById("pname").value === "") {
            alert("Please enter project name");
        }
        else {
            let mapping = {};
            mapping["username"] = localStorage.getItem('CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser');
            mapping['project'] = document.getElementById('pname').value.trimEnd();

            try {
                let tempd = await API.graphql({
                    query: createEduvanceAITool, variables: {
                        input: {
                            projectname: mapping['username'] + "//Advance//" + mapping['project'],
                            user: mapping['username'],
                            projectType: "Advance",
                            projectData: codetemp
                            // extraField1:""                                   
                        }
                    }
                });
                setModelSaved(true);
            }
            catch {
                let tempd = await API.graphql({
                    query: updateEduvanceAITool, variables: {
                        input: {
                            projectname: mapping['username'] + "//Advance//" + mapping['project'],
                            user: mapping['username'],
                            projectType: "Advance",
                            projectData: codetemp
                            // extraField1:""                                   
                        }
                    }
                });
                setModelSaved(true);

            }
        }
    }

    // useEffect(() => {
    //     fetchValidity();
    //   }, []);

    async function fetchValidity() {

        var username = localStorage.getItem('CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser');
        var userdata = localStorage.getItem(`CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`);
        var jsondata = JSON.parse(userdata);
        var emailid = `${username}//${ jsondata["UserAttributes"][jsondata["UserAttributes"].length - 2]["Value"]}`;

        const apiData = await API.graphql({ query: getEduvanceAiUsers, variables: { User: emailid } });
        // console.log("data " + JSON.stringify( apiData.data.getEduvanceAiUsers['expiry']));
        if (!apiData.data.getEduvanceAiUsers) {
            localStorage.setItem("validity", "free");

            localStorage.setItem("accountType", "Free");
        }
        else {
            if (new Date(apiData.data.getEduvanceAiUsers['expiry']) > Date.now()) {
                // console.log("yeah baby");
                localStorage.setItem("validity", apiData.data.getEduvanceAiUsers['expiry']);
                setIsPremium(true);
                localStorage.setItem("accountType", "Premium");

            }
            else {
                localStorage.setItem("validity", "free");
                localStorage.setItem("accountType", "Free");
                // console.log("bad babdy");
            }
        }
        // apiData.data.getEduvanceAiUsers.items.forEach(item => {
        //     console.log("item "+JSON.stringify(item));
        // })

    }


    return (
        <div>
            <div>
                <img id="backgroundmainimage" src="./assets/images/background/MainBackground.png" />
            </div>

            <Snackbar open={modelSaved} autoHideDuration={6000} message="Model Saved"
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                action={
                    <React.Fragment>
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            onClick={handleModelSavedClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    </React.Fragment>
                }

                onClose={handleModelSavedClose}>
                {/* <Alert onClose={handleModelSavedClose} severity="success" >
                Model Saved
            </Alert> */}

            </Snackbar>

            <Modal
                open={couponModalOpen}
                onClose={handleCouponModalClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className={classes.modal}
                BackdropComponent={Backdrop}
            >
                <div className="text-center" className={classes.paper}>
                    <TextField id="couponid" style={{ width: "11rem" }} placeholder="Enter Coupon" /><br></br><br></br>
                    <span>Please mail at contact@eduvance.in to get coupon.</span>
                    <Button variant="contained" color="primary" component="span" onClick={verifyCoupon} >
                        SUBMIT
                    </Button>
                </div>
            </Modal>

            <div className="container-fluid navcontent">
                <div className="row justify-content-between">
                    <div className="col-auto align-self-end">
                        <div >
                            <Grid style={{ display: "flex" }}>
                                <Grid item>
                                    <Link to="/advance">
                                        <Button variant="contained" color="primary" component="span" >Back</Button>
                                    </Link>
                                </Grid>
                                {/* <AccountCircleIcon style={{marginLeft:"1vw"}} /> */}
                                {/* {isPremium?
                            <>
                            <Typography style={{paddingRight:"1vw",paddingTop:"2vh",paddingLeft:"2vw",fontSize:"1.5vw"}}>Premium User</Typography>
                            <Typography style={{fontSize:"1.5vw",paddingTop:"2vh"}} >Validity:{localStorage.getItem("validity").substring(3,16)}</Typography>
                            </>
                            :
                            <>
                            <Typography style={{paddingLeft:"2vw",paddingTop:"2vh",paddingRight:"8vw",fontSize:"1.5vw"}}>Free User</Typography>                          
                            <a href="#" onClick={()=>{setCouponModalOpen(true)}} style={{paddingLeft:"5vw",paddingTop:"2vh"}}>+</a>
                            </>
                            } */}
                            </Grid>


                        </div>
                    </div>
                    <div className="col-auto align-self-end">

                        <Grid container spacing={1}>
                            {/* <Grid item>
                                <Link to="/">
                                    <Button variant="contained" color="secondary" component="span" >Home</Button>
                                </Link>
                            </Grid> */}
                            {/* <Grid item>
                                <Link to="/advance">
                                    <Button variant="contained" color="primary" component="span"  >Back</Button>
                                </Link>
                            </Grid> */}
                            <Grid item>
                                {runButtonStatus ?
                                            <Button variant="contained" color="primary" component="span" disabled={true} style={{color:"white",background:"grey"}}
                                            startIcon={<CircularProgress style={{ width: "1vw", height: "1vw" }} color="primary" />}>RUN</Button>
                                        :
                                            <Button variant="contained" color="primary" component="span"  onClick={handleRun} >RUN</Button>
                                    }
                            </Grid>

                            {/* <Grid item>

                                {runButtonStatus ?
                                    <Grid item>
                                        <CircularProgress style={{ width: "2vw", height: "2vw" }} color="primary" />
                                    </Grid>
                                    : <></>
                                }

                            </Grid> */}
                            <Grid item>
                                <input id="pname" className='myinput' style={{ marginRight: "2vw" }} type='text' placeholder='Enter project name' />
                                <Button variant="contained" color="primary" component="span" onClick={saveModel} >
                                    SAVE Project
                                </Button>
                            </Grid>

                        </Grid>

                    </div>
                    <div className="col-auto align-self-end">
                        <Grid container spacing={1}>
                            <Grid item>
                                <Link to="/">
                                    <Button variant="contained" color="primary" component="span"  >Home</Button>
                                </Link>
                            </Grid>
                            {/* <Grid item>
                            <Button style={{ backgroundColor: "#ffa502" }} variant="contained" onClick={() => { signOut() }} component="span" color="secondary">Sign Out</Button>
                        </Grid> */}
                        </Grid>

                    </div>

                </div>
            </div>



            {/* <div className="container myct">
                <div className="row justify-content-center">
                    <div className="col-7">
                        <Grid container spacing={1}>
                            <Grid item>
                                <Link to="/">
                                    <Button variant="contained" color="secondary" component="span" >Home</Button>
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link to="/advance">
                                    <Button variant="contained" color="secondary" component="span" >Back</Button>
                                </Link>
                            </Grid>
                            <Grid item>
                                <Button id="runButton" disabled={runButtonStatus} variant="contained" color="secondary" component="span" onClick={e => { console.log(codetemp); handleRun(); }}>RUN</Button>
                            </Grid>
                            {runButtonStatus?
                                <Grid item>
                                     <CircularProgress />
                                </Grid>
                                : <></>
                            }

                        </Grid>
                    </div>

                </div>
            </div> */}

            <div className="bringfront">
                {/* <div id="editor">print("hello")</div> */}
                {/* <textarea id="code" className="prism-live line-numbers language-py tarea"> #write your code below</textarea> */}
                {/* </div> */}
                <div className="tarea">
                    <div className='codeheader'>
                        CODE
                    </div>
                    <CodeMirror
                        onChange={(editor, data, value) => { setCodetemp(editor.getValue()); }}
                        value={code}
                        options={{
                            theme: 'monokai',
                            keyMap: 'sublime',
                            mode: 'python',
                            lineWrapping: true,
                            indentUnit: 4,
                            viewportMargin: Infinity,
                        }}
                    />
                </div>

                <div className='consoleheader'>
                    CONSOLE
                </div>
                <div className="mycard">

                    {exitCode === "1" ?
                        <>

                            <span style={{ color: "red" }}><b> ERROR:</b><br></br></span><pre> {errorData}<br></br><br></br></pre>
                        </>
                        :
                        <>
                            <span style={{ color: "green" }}><b>OUTPUT:</b><br></br></span><pre> {outputData}<br></br><br></br></pre>
                        </>
                    }
                </div>



            </div>



        </div>
    );



}

export default Advance